import { IMessage } from "../endpoints/types/message.type";

export function isUnreadIncomingMessage(message: IMessage, peerId: string, selfIds: string[]): boolean {
  return !!peerId && message.seen !== true &&
    (message.senderId || message.createdBy) === peerId &&
    selfIds.includes(message.recipientId || message.receivedBy);
}

export function applyReadReceipt(messages: IMessage[], receipt: IMessage): IMessage[] {
  const receiptId = receipt?._id || receipt?.messageId;
  return messages.map(message =>
    (receiptId && (message.messageId === receiptId || message._id === receiptId)) ||
    (receipt?.clientMsgId && message.clientMsgId === receipt.clientMsgId)
      ? { ...message, seen: true } : message);
}
